
import { v4 as uuidv4 } from "uuid";
import { 
  IStringNumHash, 
} from "@models";
import { 
  Creature,
  AbilityScores,
  HitDice, 
  CharacterFeature,
  UpgradableNumber,
  CharacterAbility,
  CreatureHP,
  CharacterResourceHolder,
  CreatureGift,
  DamageTypeOverridesTable,
  CharacterSubscriptionHolder,
  CharacterItem,
  CharacterRace,
  SKILLS,
  CharacterCondition,
  CreatureAbility,
} from "@dndModels";
import { 
  ABILITY_SCORES, 
  DAMAGE_TYPES, 
  HIT_DICE_SIZE_MAP, 
  SIZE_MAP, 
  SIZE_TO_NUM_MAP 
} from "@dndModels/Constants";
import { AbilityScoreType } from "@dndModels/Types";
import DataUtilities from "@dndUtilities/data_utilities";
import DandDCharacterUtilities from "@dndUtilities/char_utilities";
import CommonUtilities from "@utilities/common_utilities";

const data_util = DataUtilities.getInstance();
const char_util = DandDCharacterUtilities.getInstance();
const common_util = CommonUtilities.getInstance();

export class CreatureInstance {
  true_id = "";
  _name = "";
  subscription_holder: CharacterSubscriptionHolder = new CharacterSubscriptionHolder();
  get name() {
    let name = this._name;
    if (name === "" && this.creature) {
      name = this.creature.name_for_cr(this.challenge_rating);
      for (const cg of this.creature_gifts) {
        const gift = cg.gift;
        if (gift) {
          if (gift.name_formula.length > 0) {
            let new_name = gift.name_formula;
            if (gift.name_formula.includes("replace.")) {
              // debugger;
              // {replace.Dragon.Shadow Dragon}
              new_name = new_name.replace("{","").replace("}","");
              const pieces = new_name.split(".");
              if (pieces.length === 3) {
                new_name = name.replace(pieces[1], pieces[2]);
              }
            } else {
              new_name = new_name.replace("{base.name}", name);
              new_name = new_name.replace("{gift.name}", gift.name);
              new_name = new_name.replace("{gift.level}", cg.level > 1 ? `${cg.level}` : "");
            }
            name = new_name;
          }
        }
      }
      if (this._num > 1) {
        name += " " + this._num;
      }
    }
    return name;
  }
  set name(value: string) {
    this._name = value;
  }
  _num = 1;
  get description() {
    let description = this.creature ? this.creature.description : "";
    for (const cg of this.creature_gifts) {
      const gift = cg.gift;
      if (gift && gift.description.length > 0) {
        description += `\r\n\r\n <b>${gift.name}</b>\r\n ${gift.description}`;
      }
    }
    return description
  }
  stat_block_id = "";
  connected = false;
  is_new = true;
  base_slot_level = -1;
  slot_level = -1;
  
  challenge_rating = 0;
  challenge_rating_modifier = 0;
  get use_challenge_rating() {
    return this.challenge_rating + this.challenge_rating_modifier;
  }
  
  get creature_type() {
    // debugger;
    let creature_type = this.creature ? this.creature.creature_type : "";
    const overrider = this.creature_gifts.find(o => o.gift && o.gift.override_type !== "None");
    if (overrider && overrider.gift) {
      creature_type = overrider.gift.override_type;
    }
    return creature_type;
  }
  get subtypes() {
    let subtypes = this.creature ? this.creature.subtypes : [];
    for (const cg of this.creature_gifts) {
      if (cg.gift) {
        let gift_subtypes = cg.gift.bonus_subtypes;
         
        subtypes = [...subtypes,...gift_subtypes.filter(o => !subtypes.includes(o))];
        gift_subtypes = cg.gift.remove_subtypes;
        subtypes = subtypes.filter(o => !gift_subtypes.includes(o));
      }
    }
    return subtypes;
  }
  get creature_type_string() {
    return `${this.subtypes.length > 0 ? this.subtypes.join(" ") + " " : ""}${this.creature_type}`;
  }

  resource_holder: CharacterResourceHolder = new CharacterResourceHolder();
  get hp() {
    return this.resource_holder.hp;
  }
  get hit_dice() {
    return this.resource_holder.hit_dice;
  }
  hit_dice_bonus = 0;
  extra_hp_pools: CreatureHP[] = [];

  initiative_modifier = 0;
  armor_class = 0;

  get use_ac() {
    return this.armor_class;
  }
  size = "";

  get use_size() {
    return this.size;
  }
  alignment = "";
  // attributes
  current_speed: IStringNumHash = {
    walk: 0,
    swim: 0,
    climb: 0,
    fly: 0,
    burrow: 0,
    hover: 0
  };
  speed: IStringNumHash = {
    walk: 0,
    swim: 0,
    climb: 0,
    fly: 0,
    burrow: 0,
    hover: 0
  };
  current_senses: IStringNumHash = {};
  senses: IStringNumHash = {};
  passives: IStringNumHash = {
    passive_perception: 0,
    passive_insight: 0,
    passive_investigation: 0
  };

  favorite_conditions: string[] = [];
  // condition_hash: { [id: string]: { level: number, source_true_id: string } } = {};
  condition_immunities: string[] = [];
  conditions: CharacterCondition[] = [];

  get condition_hash() {
    const hash:{ [id: string]: { level: number, source_true_id: string } } = {};
    for (const cc of this.conditions) {
      hash[cc.source_id] = { level: cc.level, source_true_id: cc.condition_source_true_id };
    }
    return hash;
  }

  // get damage_immunities() {
    
  // }
  damage_immunities: string[] = [];
  extra_damage_immunities = "";
  damage_resistances: string[] = [];
  extra_damage_resistances = "";
  damage_vulnerabilities: string[] = [];
  extra_damage_vulnerabilities = "";

  tool_proficiencies: string[] = [];
  skill_proficiencies2: { skill_id: string, prof_level: number, skill_name: string, modifier: number }[] = [];
  saving_throws: IStringNumHash = {
    STR: 0, DEX: 0, CON: 0, 
    INT: 0, WIS: 0, CHA: 0
  };
  languages = "";

  
  current_ability_scores: AbilityScores = new AbilityScores();
  ability_scores: AbilityScores = new AbilityScores();

  use_resources: {
    resource_id: string, // Can be "Slot:Level" or "Pact:Level"
    used: number,
    total: number,
    size: number
  }[] = [];

  actions: CharacterFeature[] = [];
  special_abilities: CharacterFeature[] = [];
  legendary_actions: CharacterFeature[] = [];
  lair_actions: CharacterFeature[] = [];
  abilities: CharacterAbility[] = [];
  
  mishaps: CharacterFeature[] = [];
  stations: CharacterFeature[] = [];

  get action_cfs() {
    return this.actions.filter(o => !(o.floating_feature instanceof CreatureAbility) || (o.floating_feature.casting_time !== "BA" && o.floating_feature.casting_time !== "RA"));
  }
  get bonus_actions() {
    return this.actions.filter(o => o.floating_feature instanceof CreatureAbility && o.floating_feature.casting_time === "BA");
  }
  get reactions() {
    return this.actions.filter(o => o.floating_feature instanceof CreatureAbility && o.floating_feature.casting_time === "RA");
  }

  used_legendary_actions = 0;
  legendary_actions_per_round = 0;
  used_legendary_resistances = 0;
  legendary_resistances = 0;
  used_slots: { [level: number]: number } = {};
  extra_attacks = 0;
  extra_attacks_string = "";

  creature_id = "";
  creature: Creature | null = null;
  creature_gifts: CreatureInstanceGift[] = [];

  humanoid_race_id = "";
  humanoid_subrace_id = "";
  humanoid_race: CharacterRace[] = [];

  gear_items: CharacterItem[] = [];

  get proficiency_modifier(): number {
    return common_util.proficiencyBonus(this.use_challenge_rating);
  }

  value = 0;

  constructor(obj?: any) {
    this.is_new = obj ? false : true;
    this.true_id = obj ? obj.true_id : uuidv4().toString();
    if (obj) {
      // console.log(obj);
      // console.log(this);
      this.stat_block_id = obj.stat_block_id ? obj.stat_block_id : "";
      this.creature_id = obj.creature_id ? obj.creature_id : "";
      this.creature_gifts = obj.creature_gifts ? obj.creature_gifts.map((o: any) => new CreatureInstanceGift(o)) : [];
      this.base_slot_level = obj.base_slot_level ? obj.base_slot_level : -1;
      this.slot_level = obj.slot_level ? obj.slot_level : -1;
      this._name = obj.name ? obj.name : "";
      this._num = obj._num ? obj._num : 1;
      this.challenge_rating = obj.challenge_rating ? obj.challenge_rating : 0;
      // this.image_url = obj.image_url ? obj.image_url : "";
      this.current_ability_scores = obj.current_ability_scores ? new AbilityScores(obj.current_ability_scores) : new AbilityScores();
      this.ability_scores = obj.ability_scores ? new AbilityScores(obj.ability_scores) : new AbilityScores();
    
      this.use_resources = obj.resources ? obj.resources : [];
      this.use_resources.forEach(r => {
        if (!r.size) {
          r.size = 1;
        }
      });

      this.actions = [];
      if (obj.actions && obj.actions.length > 0) {
        obj.actions.forEach((o: any) => {
          this.actions.push(new CharacterFeature(o));
        });
      }

      this.special_abilities = [];
      if (obj.special_abilities && obj.special_abilities.length > 0) {
        obj.special_abilities.forEach((o: any) => {
          this.special_abilities.push(new CharacterFeature(o));
        });
      }

      this.legendary_actions = [];
      this.legendary_actions_per_round = obj.legendary_actions_per_round ? obj.legendary_actions_per_round : 0;
      this.used_legendary_actions = obj.used_legendary_actions ? obj.used_legendary_actions : 0;
      this.used_slots = obj.used_slots ? {...obj.used_slots} : {};
      if (obj.legendary_actions && obj.legendary_actions.length > 0) {
        obj.legendary_actions.forEach((o: any) => {
          this.legendary_actions.push(new CharacterFeature(o));
        });
      }
      this.legendary_resistances = obj.legendary_resistances ? obj.legendary_resistances : 0;
      this.used_legendary_resistances = obj.used_legendary_resistances ? obj.used_legendary_resistances : 0;

      this.lair_actions = [];
      if (obj.lair_actions && obj.lair_actions.length > 0) {
        obj.lair_actions.forEach((o: any) => {
          this.lair_actions.push(new CharacterFeature(o));
        });
      }

      this.abilities = [];
      if (obj.abilities && obj.abilities.length > 0) {
        obj.abilities.forEach((o: any) => {
          this.abilities.push(new CharacterAbility(o));
        });
      }
      
      if (obj.resource_holder) {
        this.resource_holder = new CharacterResourceHolder(obj.resource_holder);
      } else {
        this.resource_holder = new CharacterResourceHolder();
        this.resource_holder.hp = obj.hp ? new CreatureHP(obj.hp) : new CreatureHP();
        this.resource_holder.hit_dice = []; 
        if (obj.hit_dice) {
          if (obj.hit_dice.length) {
            obj.hit_dice.forEach((hd: any) => {
              this.resource_holder.hit_dice.push(new HitDice(hd));
            });
          } else {
            this.resource_holder.hit_dice.push(new HitDice(obj.hit_dice));
          }
        }
      }
      this.hit_dice_bonus = obj.hit_dice_bonus ? obj.hit_dice_bonus : 0;
      
      this.current_speed = obj.current_speed ? obj.current_speed : {
        walk: 0,
        swim: 0,
        climb: 0,
        fly: 0,
        burrow: 0,
        hover: 0
      };
      this.speed = obj.speed ? obj.speed : {
        walk: 0,
        swim: 0,
        climb: 0,
        fly: 0,
        burrow: 0,
        hover: 0
      };
      this.passives = obj.passives ? obj.passives : {
        passive_perception: 0,
        passive_insight: 0,
        passive_investigation: 0
      };
      this.saving_throws = obj.saving_throws ? obj.saving_throws : {
        STR: 0, DEX: 0, CON: 0, 
        INT: 0, WIS: 0, CHA: 0
      };
      this.languages = obj.languages ? obj.languages : "";
      this.tool_proficiencies = [];
      if (obj.tool_proficiencies && obj.tool_proficiencies.length > 0) {
        this.tool_proficiencies = obj.tool_proficiencies;
      }
      this.skill_proficiencies2 = obj.skill_proficiencies2 ? obj.skill_proficiencies2 : [];
      this.initiative_modifier = obj.initiative_modifier ? obj.initiative_modifier : 0;
      this.armor_class = obj.armor_class ? obj.armor_class : 0;
      this.size = obj.size ? obj.size : "Medium";
      this.alignment = obj.alignment ? obj.alignment : "Neutral";
      // this.xp = obj.xp ? obj.xp : 0;
     
      this.favorite_conditions = obj.favorite_conditions ? obj.favorite_conditions : [];
      // this.condition_hash = {};
      // if (obj.condition_hash) {
      //   const cond_ids = Object.keys(obj.condition_hash);
      //   for (const cond_id of cond_ids) {
      //     if (typeof obj.condition_hash[cond_id] === "object") {
      //       this.condition_hash[cond_id] = obj.condition_hash[cond_id];
      //     } else {
      //       this.condition_hash[cond_id] = { level: obj.condition_hash[cond_id], source_true_id: "" };
      //     }
      //   }
      // }
      this.conditions = [];
      if (obj && obj.conditions) {
        for (let i = 0; i < obj.conditions.length; i++) {
          const cc = new CharacterCondition(obj.conditions[i]);
          this.conditions.push(cc);
        }
      }
      this.condition_immunities = obj.condition_immunities ? obj.condition_immunities : [];
      
      this.extra_damage_immunities = obj.extra_damage_immunities ? obj.extra_damage_immunities : "";
      this.damage_immunities = [];
      if (obj.damage_immunities && obj.damage_immunities.length > 0) {
        this.damage_immunities = obj.damage_immunities;
      } else if (obj.damage_multipliers && obj.damage_multipliers.length > 0) {
        obj.damage_multipliers.filter((o: any) => o.multiplier === 0).forEach((dm: any) => {
          this.damage_immunities = [...this.damage_immunities,...dm.damage_types];
        });
      }
      this.damage_immunities = this.damage_immunities.filter(o => o.length > 0).map(o => {
        return o[0].toLocaleUpperCase() + o.substring(1);
      });
      let non_fitting = this.damage_immunities.filter(o => !DAMAGE_TYPES.includes(o));
      this.damage_immunities = this.damage_immunities.filter(o => DAMAGE_TYPES.includes(o));
      if (non_fitting.length > 0) {
        if (this.extra_damage_immunities.length > 0) {
          this.extra_damage_immunities += ", ";
        }
        this.extra_damage_immunities += non_fitting.join(", ");
      }
      this.extra_damage_resistances = obj.extra_damage_resistances ? obj.extra_damage_resistances : "";
      this.damage_resistances = [];
      if (obj.damage_resistances && obj.damage_resistances.length > 0) {
        this.damage_resistances = obj.damage_resistances;
      } else if (obj.damage_multipliers && obj.damage_multipliers.length > 0) {
        obj.damage_multipliers.filter((o: any) => o.multiplier === 0.5).forEach((dm: any) => {
          this.damage_resistances = [...this.damage_resistances,...dm.damage_types];
        });
      }
      this.damage_resistances = this.damage_resistances.filter(o => o.length > 0).map(o => {
        return o[0].toLocaleUpperCase() + o.substring(1);
      });
      non_fitting = this.damage_resistances.filter(o => !DAMAGE_TYPES.includes(o));
      this.damage_resistances = this.damage_resistances.filter(o => DAMAGE_TYPES.includes(o));
      if (non_fitting.length > 0) {
        if (this.extra_damage_resistances.length > 0) {
          this.extra_damage_resistances += ", ";
        }
        this.extra_damage_resistances += non_fitting.join(", ");
      }
      this.extra_damage_vulnerabilities = obj.extra_damage_vulnerabilities ? obj.extra_damage_vulnerabilities : "";
      this.damage_vulnerabilities = [];
      if (obj.damage_vulnerabilities && obj.damage_vulnerabilities.length > 0) {
        this.damage_vulnerabilities = obj.damage_vulnerabilities;
      } else if (obj.damage_multipliers && obj.damage_multipliers.length > 0) {
        obj.damage_multipliers.filter((o: any) => o.multiplier === 2).forEach((dm: any) => {
          this.damage_vulnerabilities = [...this.damage_vulnerabilities,...dm.damage_types];
        });
      }
      this.damage_vulnerabilities = this.damage_vulnerabilities.filter(o => o.length > 0).map(o => {
        return o[0].toLocaleUpperCase() + o.substring(1);
      });
      non_fitting = this.damage_vulnerabilities.filter(o => !DAMAGE_TYPES.includes(o));
      this.damage_vulnerabilities = this.damage_vulnerabilities.filter(o => DAMAGE_TYPES.includes(o));
      if (non_fitting.length > 0) {
        if (this.extra_damage_vulnerabilities.length > 0) {
          this.extra_damage_vulnerabilities += ", ";
        }
        this.extra_damage_vulnerabilities += non_fitting.join(", ");
      }
      
      this.senses = {};
      if (obj.senses) {
        if (obj.senses.length > 0) {
          obj.senses.forEach((sense: any) => {
            console.log(sense);
            // this.senses[sense.name] = sense.range;
            // this.senses.push(new CharacterSense(sense));
          });
        } else {
          this.senses = obj.senses;
        }
      }
      this.current_senses = {};
      if (obj.current_senses) {
        if (obj.current_senses.length > 0) {
          obj.current_senses.forEach((sense: any) => {
            console.log(sense);
            // this.senses[sense.name] = sense.range;
            // this.current_senses.push(new CharacterSense(sense));
          });
        } else {
          this.current_senses = obj.current_senses;
        }
      }

      this.value = obj.value ? obj.value : 0;
    }
  }

  toDBObj(): any {
    return {
      true_id: this.true_id,
      stat_block_id: this.stat_block_id,
      creature_id: this.creature_id,
      creature_gifts: this.creature_gifts.map(o => o.toDBObj()),
      base_slot_level: this.base_slot_level,
      slot_level: this.slot_level,
      instance_type: "Creature",
      name: this._name,
      _num: this._num,
      current_ability_scores: this.current_ability_scores.toDBObj(),
      ability_scores: this.ability_scores.toDBObj(),
      hit_dice_bonus: this.hit_dice_bonus,
      resources: this.use_resources,
      actions: this.actions.map(o => o.toDBObj()),
      legendary_actions: this.legendary_actions.map(o => o.toDBObj()),
      legendary_actions_per_round: this.legendary_actions_per_round,
      used_legendary_actions: this.used_legendary_actions,
      used_slots: {...this.used_slots},
      lair_actions: this.lair_actions.map(o => o.toDBObj()),
      legendary_resistances: this.legendary_resistances,
      used_legendary_resistances: this.used_legendary_resistances,
      special_abilities: this.special_abilities.map(o => o.toDBObj()),
      abilities: this.abilities.map(o => o.toDBObj()),
      challenge_rating: this.challenge_rating,
      resource_holder: this.resource_holder.toDBObj(),
      current_speed: this.current_speed,
      speed: this.speed,
      passives: this.passives,
      saving_throws: this.saving_throws,
      skill_proficiencies2: this.skill_proficiencies2,
      tool_proficiencies: this.tool_proficiencies,
      initiative_modifier: this.initiative_modifier,
      armor_class: this.armor_class,
      size: this.size,
      alignment: this.alignment,
      // xp: this.xp,
      favorite_conditions: this.favorite_conditions,
      // condition_hash: this.condition_hash,
      conditions: this.conditions.map(o => o.toDBObj()),
      condition_immunities: this.condition_immunities,
      damage_immunities: this.damage_immunities,
      extra_damage_immunities: this.extra_damage_immunities,
      damage_resistances: this.damage_resistances,
      extra_damage_resistances: this.extra_damage_resistances,
      damage_vulnerabilities: this.damage_vulnerabilities,
      extra_damage_vulnerabilities: this.damage_vulnerabilities,
      languages: this.languages,
      value: this.value
    };
  }

  get_use_name(): string {
    if (this.creature) {
      return this.creature.name_for_cr(this.challenge_rating);
    }
    return "";
  }

  get_speed(type: string): number {
    const the_speed = (this.speed as any)[type];
    if (the_speed) {
      return the_speed;
    }
    return 0;
  }

  get hit_dice_string(): string {
    let response = "";
    this.hit_dice.forEach(hd => {
      if (response.length > 0) {
        response += ", ";
      }
      response += `${hd.count}d${hd.size}`;
    });
    if (this.hit_dice_bonus < 0) {
      response += ` ${this.hit_dice_bonus}`;
    } else if (this.hit_dice_bonus > 0) {
      response += ` + ${this.hit_dice_bonus}`;
    }
    return response;
  }

  get skills_string(): string {
    return this.skill_proficiencies2.map(o => { return `${o.skill_name}: ${o.modifier < 0 ? o.modifier : "+" + o.modifier}`; }).join(", ");
  }

  get tools_string(): string {
    return this.tool_proficiencies.join(", ");
  }

  get senses_string(): string {
    let response = "";
    Object.keys(this.current_senses).forEach(key => {
      if (response.length > 0) {
        response += ", ";
      }
      response += `${key} ${this.current_senses[key]} ft.`;
    });
    if (this.passives.passive_perception > 0) {
      if (response.length > 0) {
        response += ", ";
      }
      response += `Passive Perception: ${this.passives.passive_perception}`;
    }
    if (this.passives.passive_insight > 0) {
      if (response.length > 0) {
        response += ", ";
      }
      response += `Passive Insight: ${this.passives.passive_insight}`;
    }
    if (this.passives.passive_investigation > 0) {
      if (response.length > 0) {
        response += ", ";
      }
      response += `Passive Investigation: ${this.passives.passive_investigation}`;
    }
    return response;
  }
  get passive_perception() {
    let passive_perception = 10 + this.current_ability_scores.WIS;
    const perception = this.skill_proficiencies2.find(o => o.skill_id === "5fef742e7494ba20cca8a9ec" || o.skill_id === "Perception");
    if (perception) {
      passive_perception += this.proficiency_modifier;
    }
    return passive_perception;
  }
  get small_name() {
    return this.creature ? this.creature.small_name : this.name;
  }

  get saving_throws_string(): string {
    let response = "";
    Object.keys(this.saving_throws).forEach(key => {
      if (response.length > 0) {
        response += ", ";
      }
      response += `${key}: `;
      if (this.saving_throws[key] > 0) {
        response += "+";
      }
      response += `${this.saving_throws[key]}`;
    });
    return response;
  }

  get_saving_throw(ability: AbilityScoreType) {
    let modifier: number | null | undefined = this.saving_throws[ability];
    if (!modifier) {
      modifier = this.current_ability_scores.getModifier(ability);
    }
    if (!modifier) {
      return 0
    } else {
      return modifier;
    }
  }
  saving_throw(ability: AbilityScoreType) {
    return this.get_saving_throw(ability);
  }

  get speed_string(): string {
    let response = "";
    Object.keys(this.current_speed).forEach(key => {
      if (this.current_speed[key]) {
        if (response.length > 0) {
          response += ", ";
        }
        if (key === "hover") {
          if (this.current_speed[key] === 1) {
            response += "hover";
          } else {
            response += "no hover";
          }
        } else {
          response += `${key} ${this.current_speed[key]} ft.`;
        }
      }
    });
    return response;
  }

  get immunities_string(): string {
    let str = this.damage_immunities.join(", ");
    if (this.extra_damage_immunities.length > 0) {
      if (str.length > 0) {
        str += ", ";
      }
      str += this.extra_damage_immunities;
    }
    return str;
  }

  get resistances_string(): string {
    let str = this.damage_resistances.join(", ");
    if (this.extra_damage_resistances.length > 0) {
      if (str.length > 0) {
        str += ", ";
      }
      str += this.extra_damage_resistances;
    }
    return str;
  }

  get vulnerabilities_string(): string {
    let str = this.damage_vulnerabilities.join(", ");
    if (this.extra_damage_vulnerabilities.length > 0) {
      if (str.length > 0) {
        str += ", ";
      }
      str += this.extra_damage_vulnerabilities;
    }
    return str;
  }

  get condition_immunities_string(): string {
    return this.condition_immunities.join(", ");
  }

  get true_max_hit_points() {
    return this.hp.true_max;
  }

  get spellcasting_ability() {
    return this.creature?.spellcasting_ability??"None";
  }

  get spell_dc() {
    return this.creature ? this.creature.spell_dc : new UpgradableNumber();
  }

  get dc() {
    return this.spell_dc;
  }

  get spell_attack() {
    return this.creature ? this.creature.spell_attack : new UpgradableNumber();
  }

  get non_magic_attack() {
    return this.creature ? this.creature.non_magic_attack : new UpgradableNumber();
  }

  get magic_dmg_bonus() {
    return this.creature ? this.creature.magic_dmg_bonus : new UpgradableNumber();
  }

  get non_magic_dmg_bonus() {
    return this.creature ? this.creature.non_magic_dmg_bonus : new UpgradableNumber();
  }

  get spellcasting_description(): string {
    if (this.creature) {
      const spellcasting_entry = this.creature.spellcasting_table.getEntry(this.challenge_rating);
      if (spellcasting_entry) {
        return spellcasting_entry.description;
      }
    }
    return "";
  }

  get use_spells() {
    if (this.creature) {
      const spellcasting_entry = this.creature.spellcasting_table.getEntry(this.challenge_rating);
      if (spellcasting_entry) {
        return spellcasting_entry.spells;
      }
    }
    return [];
  }

  get spell_levels() {
    if (this.creature) {
      const spellcasting_entry = this.creature.spellcasting_table.getEntry(this.challenge_rating);
      if (spellcasting_entry) {
        return spellcasting_entry.spell_levels;
      }
    }
    return [];
  }

  x_per_day_for(spell_id: string) {
    if (this.creature) {
      const entry = this.creature.spellcasting_table.getEntry(this.challenge_rating);
      if (entry) {
        const spell = entry.spells.find(o => o.spell_id === spell_id);
        if (spell) {
          return spell.x;
        }
      }
    }
    return 0;
  }

  get string_hash() {
    return this.creature ? this.creature.string_hash : {};
  }

  get upgradable_hash() {
    return this.creature ? this.creature.upgradable_hash : {};
  }

  get use_slots2() {
    return this.use_resources.filter(o => o.resource_id.includes("Slot"));
  }

  get image_url() {
    return this.creature?.image_url??"";
  }

  copy(copyMe: CreatureInstance, drop_ids = false): void {
    if (!drop_ids) {
      this.true_id = copyMe.true_id;
    }
    this._name = copyMe._name;
    this._num = copyMe._num;
    this.creature = copyMe.creature;
    this.creature_id = copyMe.creature_id;
    this.creature_gifts = copyMe.creature_gifts.map(o => o.clone());
    this.current_ability_scores = new AbilityScores(copyMe.current_ability_scores);
    this.ability_scores = new AbilityScores(copyMe.ability_scores);
    this.hit_dice_bonus = copyMe.hit_dice_bonus;
    this.challenge_rating = copyMe.challenge_rating;

    this.resource_holder = copyMe.resource_holder.clone();

    this.current_speed = {...copyMe.current_speed};
    this.speed = {...copyMe.speed};
    this.passives = {...copyMe.passives};
    this.saving_throws = {...copyMe.saving_throws};
    this.skill_proficiencies2 = copyMe.skill_proficiencies2.map(o => { return { ...o }; });
    this.tool_proficiencies = [...copyMe.tool_proficiencies];
    this.initiative_modifier = copyMe.initiative_modifier;
    this.armor_class = copyMe.armor_class;
    this.use_resources = copyMe.use_resources.map(o => { return {...o}; });
    this.actions = copyMe.actions.map(o => o.clone());
    this.legendary_actions = copyMe.legendary_actions.map(o => o.clone());
    this.legendary_actions_per_round = copyMe.legendary_actions_per_round;
    this.used_legendary_actions = copyMe.used_legendary_actions;
    this.legendary_resistances = copyMe.legendary_resistances;
    this.used_legendary_resistances = copyMe.used_legendary_resistances;
    this.used_slots = {...copyMe.used_slots};
    this.lair_actions = copyMe.lair_actions.map(o => o.clone());

    this.special_abilities = copyMe.special_abilities.map(o => o.clone());
    this.abilities = copyMe.abilities.map(o => o.clone());

    this.size = copyMe.size;
    this.alignment = copyMe.alignment;
    // this.xp = copyMe.xp;
    this.favorite_conditions = [...copyMe.favorite_conditions];
    // this.condition_hash = {...copyMe.condition_hash};
    this.conditions = copyMe.conditions.map(o => o.clone());
    this.condition_immunities = [...copyMe.condition_immunities];

    this.damage_immunities = [...copyMe.damage_immunities];
    this.extra_damage_immunities = copyMe.extra_damage_immunities;
    this.damage_resistances = [...copyMe.damage_resistances];
    this.extra_damage_resistances = copyMe.extra_damage_resistances;
    this.damage_vulnerabilities = [...copyMe.damage_vulnerabilities];
    this.extra_damage_vulnerabilities = copyMe.extra_damage_vulnerabilities;

    this.languages = copyMe.languages;
    this.senses = { ...copyMe.senses };
    this.current_senses = { ...copyMe.current_senses };

    this.value = copyMe.value;
  }

  clone(drop_ids = false): CreatureInstance {
    const new_obj = new CreatureInstance();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }

  copyCreature = async (copyMe: Creature, challenge_rating = -1, update_all = true) => {
    this.creature = copyMe;
    this.challenge_rating = challenge_rating === -1 ? copyMe.challenge_rating : challenge_rating;
    this.challenge_rating_modifier = 0;
    this.creature_id = copyMe._id;
    this.alignment = copyMe.alignment;
    this.connected = true;
    this.current_ability_scores = char_util.toAbilityScores(copyMe.ability_scores, { obj: this });
    this.ability_scores = this.current_ability_scores.clone();

    // debugger;
    this.size = SIZE_MAP[copyMe.size_num_for_cr(this.challenge_rating)];
    this.resource_holder.hit_dice = copyMe.hit_dice.map(o => char_util.toHitDice(o, { obj: this }));
    if (this.resource_holder.hit_dice.length === 1) {
      this.resource_holder.hit_dice[0].size = HIT_DICE_SIZE_MAP[SIZE_TO_NUM_MAP[this.size]];
    }
    this.hit_dice_bonus = char_util.value(copyMe.hit_dice_bonus, { obj: this });
    this.hp.max = this.hit_dice.length === 0 ? this.hit_dice_bonus : Math.floor(
      this.hit_dice.map(o => {
        return o.count * ((o.size + 1) / 2) + o.count * this.hit_dice_bonus;
      }).reduce((a,b) => a + b, 0) // + this.hit_dice_bonus
    );
    if (this.hp.max === 0) {
      this.hp.max = this.hit_dice_bonus;
    }
    if (copyMe.starting_hp) {
      this.hp.current = char_util.value(copyMe.starting_hp, { obj: this });
      if (this.hp.current < 0) {
        this.hp.allow_negative = true;
      }
    } else {
      this.hp.current = this.hp.max;
    }

    const attributes = copyMe.attributes_table.getEntry(this.challenge_rating);
    if (attributes) {
      this.current_speed = {...attributes.speeds};
      this.speed = {...attributes.speeds};
      this.saving_throws = {}; // char_util.toIStringNumHash(copyMe.saving_throws, { obj: this });
      for (const ability_score of ABILITY_SCORES) {
        let modifier = this.ability_scores.getModifier(ability_score);
        if (attributes.save_profs.includes(ability_score as AbilityScoreType)) {
          modifier += this.proficiency_modifier;
        }
        this.saving_throws[ability_score] = modifier;
      }
      this.skill_proficiencies2 = [];
      const skill_ids = Object.keys(attributes.skill_profs);
      // console.log(skill_ids);
      for (const skill_id of skill_ids) {
        const skill = SKILLS.find(o => o._id === skill_id);
        if (skill) {
          let modifier = this.ability_scores.getModifier(skill.use_ability_score);
          modifier += this.proficiency_modifier * attributes.skill_profs[skill_id];
          this.skill_proficiencies2.push({ 
            skill_id, 
            prof_level: attributes.skill_profs[skill_id], 
            skill_name: skill.name,
            modifier
          });
        }
      }
      this.tool_proficiencies = [...attributes.tool_profs];
      // this.xp = copyMe.xp.value({ obj: this });
      this.favorite_conditions = [];
      // this.condition_hash = {};
      this.conditions = [];
      this.condition_immunities = [...attributes.condition_immunities];
  
      this.damage_immunities = [...attributes.damage_immunities];
      this.extra_damage_immunities = attributes.extra_damage_immunities;
      this.damage_resistances = [...attributes.damage_resistances];
      this.extra_damage_resistances = attributes.extra_damage_resistances;
      this.damage_vulnerabilities = [...attributes.damage_vulnerabilities];
      this.extra_damage_vulnerabilities = attributes.extra_damage_vulnerabilities;
  
      this.languages = copyMe.languages;
      this.senses = { ...attributes.senses };
      // debugger;
      this.current_senses = { ...attributes.senses };
      this.passives = {
        passive_perception: 10 + this.ability_scores.WIS,
        passive_insight: 10 + this.ability_scores.WIS,
        passive_investigation: 10 + this.ability_scores.INT
      };
      const perception = SKILLS.find(o => o.name === "Perception");
      const insight = SKILLS.find(o => o.name === "Insight");
      const investigation = SKILLS.find(o => o.name === "Investigation");
      if (perception && insight && investigation) {
        if (attributes.skill_profs[perception._id]) {
          this.passives.passive_perception += this.proficiency_modifier * attributes.skill_profs[perception._id];
        }
        if (attributes.skill_profs[insight._id]) {
          this.passives.passive_insight += this.proficiency_modifier * attributes.skill_profs[insight._id];
        }
        if (attributes.skill_profs[investigation._id]) {
          this.passives.passive_investigation += this.proficiency_modifier * attributes.skill_profs[investigation._id];
        }
      }
    }
    this.initiative_modifier = char_util.value(copyMe.initiative_modifier, { obj: this });
    this.armor_class = char_util.value(copyMe.armor_class, { obj: this });

    this.abilities = [];

    const new_resources: {
      resource_id: string, // Can be "Slot:Level" or "Pact:Level"
      used: number,
      total: number,
      size: number
    }[] = [];
    
    const resource_entry = copyMe.resources_table.getEntry(this.challenge_rating);
    if (resource_entry) {
      for (const field of copyMe.resources_table.fields.filter(o => !o.endsWith("_size"))) {
        const resource = resource_entry.data[field];
        const size = resource_entry.data[`${field}_size`];
        new_resources.push({
          resource_id: field,
          used: 0,
          total: resource,
          size: size === undefined ? 1 : size
        });
      }
    }
    this.use_resources = new_resources;

    await this.connectCreature(copyMe);
  }

  copyCreatureGift(creature_gift: CreatureGift, level: number) {
    const cig = new CreatureInstanceGift();
    cig.gift = creature_gift;
    cig.gift_id = creature_gift._id;
    cig.level = level;
    // This stuff only gets on copyCreature, not connectCreature.
    // This means that when it's getting changed by applying or removing a cg, 
    // it should only be altered at that time.
    const table_entry = creature_gift.table.getEntry(cig.level);
    if (table_entry) {
      for (const ability_score of ABILITY_SCORES) {
        this.current_ability_scores.addAbilityScore(ability_score, table_entry.data[ability_score]);
      }
      this.ability_scores = this.current_ability_scores.clone();

      // debugger;
      if (table_entry.data["Size"] !== 0) {
        const size_num = SIZE_TO_NUM_MAP[this.size] + table_entry.data["Size"];
        this.size = SIZE_MAP[size_num];
        if (this.resource_holder.hit_dice.length === 1) {
          this.resource_holder.hit_dice[0].size = HIT_DICE_SIZE_MAP[SIZE_TO_NUM_MAP[this.size]];
        }
      }
      if (table_entry.data["Hit Dice Count"] !== 0 && this.hit_dice.length === 1) {
        this.hit_dice[0].count += table_entry.data["Hit Dice Count"];
      }
      this.hit_dice_bonus = this.current_ability_scores.CON;
      this.hp.max = this.hit_dice.length === 0 ? this.hit_dice_bonus : Math.floor(
        this.hit_dice.map(o => {
          return o.count * ((o.size + 1) / 2) + o.count * this.hit_dice_bonus;
        }).reduce((a,b) => a + b, 0) // + this.hit_dice_bonus
      );
      if (this.hp.max === 0) {
        this.hp.max = this.hit_dice_bonus;
      }

      if (table_entry.data["AC"]) {
        this.armor_class += table_entry.data["AC"];
      }
      if (table_entry.data["CR"]) {
        this.challenge_rating_modifier += table_entry.data["CR"];
      }
    }
    this.passives = {
      passive_perception: 10 + this.ability_scores.WIS,
      passive_insight: 10 + this.ability_scores.WIS,
      passive_investigation: 10 + this.ability_scores.INT
    };
    const perception = SKILLS.find(o => o.name === "Perception");
    const insight = SKILLS.find(o => o.name === "Insight");
    const investigation = SKILLS.find(o => o.name === "Investigation");
    const attributes = creature_gift.attributes_table.getEntry(this.challenge_rating);
    if (attributes) {
      for (const speed of Object.keys(attributes.speeds)) {
        this.current_speed[speed] += attributes.speeds[speed];
      }
      // for (const ability_score of ABILITY_SCORES) {

      //   let modifier = this.ability_scores.getModifier(ability_score);
      //   if (attributes.save_profs.includes(ability_score as AbilityScoreType)) {
      //     modifier += this.proficiency_modifier;
      //   }
      //   this.saving_throws[ability_score] = modifier;
      // }
      // const all_skills = SKILLS;
      // const skill_ids = Object.keys(attributes.skill_profs);
      // // console.log(skill_ids);
      // for (const skill_id of skill_ids) {
      //   const skill = all_skills.find(o => o._id === skill_id);
      //   if (skill) {
      //     let modifier = this.ability_scores.getModifier(skill.use_ability_score);
      //     modifier += this.proficiency_modifier * attributes.skill_profs[skill_id];
      //     this.skill_proficiencies2.push({ 
      //       skill_id, 
      //       prof_level: attributes.skill_profs[skill_id], 
      //       skill_name: skill.name,
      //       modifier
      //     });
      //   }
      // }
      // this.tool_proficiencies = [...attributes.tool_profs];
      // this.xp = copyMe.xp.value({ obj: this });
      // this.favorite_conditions = [];
      // this.condition_hash = {};
      this.condition_immunities = [...this.condition_immunities,...attributes.condition_immunities];
  
      this.damage_immunities = [...this.damage_immunities,...attributes.damage_immunities.filter(o => !this.damage_immunities.includes(o))];
      this.extra_damage_immunities += attributes.extra_damage_immunities;
      this.damage_resistances = [...this.damage_resistances,...attributes.damage_resistances.filter(o => !this.damage_resistances.includes(o))];
      this.extra_damage_resistances += attributes.extra_damage_resistances;
      this.damage_vulnerabilities = [...this.damage_vulnerabilities,...attributes.damage_vulnerabilities.filter(o => !this.damage_vulnerabilities.includes(o))];
      this.extra_damage_vulnerabilities += attributes.extra_damage_vulnerabilities;
  
      // this.languages += copyMe.languages;
      for (const sense of Object.keys(attributes.senses)) {
        this.senses[sense] += attributes.senses[sense];
      }
      // debugger;
      if (perception && insight && investigation) {
        if (attributes.skill_profs[perception._id]) {
          this.passives.passive_perception += this.proficiency_modifier * attributes.skill_profs[perception._id];
        }
        if (attributes.skill_profs[insight._id]) {
          this.passives.passive_insight += this.proficiency_modifier * attributes.skill_profs[insight._id];
        }
        if (attributes.skill_profs[investigation._id]) {
          this.passives.passive_investigation += this.proficiency_modifier * attributes.skill_profs[investigation._id];
        }
      }
    }
    const resource_entry = creature_gift.resources_table.getEntry(this.challenge_rating);
    if (resource_entry) {
      for (const field of creature_gift.resources_table.fields.filter(o => !o.endsWith("_size"))) {
        const resource = resource_entry.data[field];
        const size = resource_entry.data[`${field}_size`];
        const old_resource = this.use_resources.find(o => o.resource_id === field);
        if (old_resource) {
          old_resource.total += resource;
          if (size) {
            old_resource.size += size;
          }
        } else {
          this.use_resources.push({
            resource_id: field,
            used: 0,
            total: resource,
            size: size === undefined ? 1 : size
          });
        }
      }
    }
    const legendaries_entry = creature_gift.legendaries_table.getEntry(this.challenge_rating);
    if (legendaries_entry) {
      this.legendary_actions_per_round += legendaries_entry.actions;
      this.legendary_resistances += legendaries_entry.resistances;
    }
    this.creature_gifts.push(cig);
  }

  connectCreature = async (copyMe: Creature, recopy = false) => {
    this.connected = true;
    this.creature = copyMe;

    // debugger;
    this.legendary_actions_per_round = copyMe.legendary_actions_for_cr(this.challenge_rating);
    this.legendary_resistances = copyMe.legendary_resistances_for_cr(this.challenge_rating);

    const old_actions = [...this.actions];
    const old_legendary_actions = [...this.legendary_actions];
    const old_lair_actions = [...this.lair_actions];
    const old_special_abilities = [...this.special_abilities];
    const old_abilities = [...this.abilities];
    const new_actions: CharacterFeature[] = [];
    const new_legendary_actions: CharacterFeature[] = [];
    const new_lair_actions: CharacterFeature[] = [];
    const new_special_abilities: CharacterFeature[] = [];
    const new_abilities: CharacterAbility[] = [];
    // console.log(copyMe);
    let use_fbs = copyMe.fbs.filter(o => o.level <= this.challenge_rating);
    let upgraded_fb_ids = use_fbs.map(fb => fb.upgrades_feature_base_id);
    use_fbs = use_fbs.filter(o => !upgraded_fb_ids.includes(o.true_id));
    for (const fb of use_fbs) {
      for (const f of fb.features) {
        // if (f.name.includes("Recharge")) {
        //   debugger;
        // }
        let f_finder = fb.creature_fb_type === "Lair Actions" ? old_lair_actions : 
          fb.creature_fb_type === "Legendary Actions" ? old_legendary_actions :
          fb.creature_fb_type === "Traits" ? old_special_abilities : 
          old_actions;
        f_finder = f_finder.filter(o => o.feature_id === f.true_id);
        if (f_finder.length === 0) {
          const cf = new CharacterFeature();
          cf.copyFeature(f, null, this);
          switch (fb.creature_fb_type) {
            case "Lair Actions": new_lair_actions.push(cf); break;
            case "Legendary Actions": new_legendary_actions.push(cf); break;
            case "Traits": new_special_abilities.push(cf); break;
            default: new_actions.push(cf); break;
          }
          
          const char_ability = new CharacterAbility();
          char_ability.copyFeature(cf, this, undefined);
          new_abilities.push(char_ability);
        } else {
          const cf = f_finder[0];
          cf.copyFeature(f, null, this);
          switch (fb.creature_fb_type) {
            case "Lair Actions": new_lair_actions.push(cf); break;
            case "Legendary Actions": new_legendary_actions.push(cf); break;
            case "Traits": new_special_abilities.push(cf); break;
            default: new_actions.push(cf); break;
          }
          let char_ability = old_abilities.find(o => o.true_id === cf.true_id);
          if (!char_ability) {
            char_ability = new CharacterAbility();
          }
          char_ability.copyFeature(cf, this, undefined);
          new_abilities.push(char_ability);
        }
      }
    }
    if (recopy) {
      const olds = this.creature_gifts.map(o => o.clone());
      this.creature_gifts = [];
      this.challenge_rating_modifier = 0;
      if (olds.length > 0) {
        const creature_gifts = await data_util.getCreatureGifts();
        for (const old of olds) {
          const gift = creature_gifts.find(o => o._id === old.gift_id);
          if (gift) {
            this.copyCreatureGift(gift, old.level);
          }
        }
      }
    } else {
      if (this.creature_gifts.length > 0) {
        const creature_gifts = await data_util.getCreatureGifts();
        for (const cg of this.creature_gifts) {
          const creature_gift = creature_gifts.find(o => o._id === cg.gift_id);
          if (creature_gift) {

            cg.connectCreatureGift(creature_gift);

            use_fbs = creature_gift.fbs.filter(o => o.level <= cg.level);
            upgraded_fb_ids = use_fbs.map(fb => fb.upgrades_feature_base_id);  
            use_fbs = use_fbs.filter(o => !upgraded_fb_ids.includes(o.true_id));
            for (const fb of use_fbs) {
              for (const f of fb.features) {
                let f_finder = fb.creature_fb_type === "Lair Actions" ? old_lair_actions : 
                  fb.creature_fb_type === "Legendary Actions" ? old_legendary_actions :
                  fb.creature_fb_type === "Traits" ? old_special_abilities : 
                  old_actions;
                f_finder = f_finder.filter(o => o.feature_id === f.true_id);
                if (f_finder.length === 0) {
                  const cf = new CharacterFeature();
                  cf.copyFeature(f, null, this);
                  switch (fb.creature_fb_type) {
                    case "Lair Actions": new_lair_actions.push(cf); break;
                    case "Legendary Actions": new_legendary_actions.push(cf); break;
                    case "Traits": new_special_abilities.push(cf); break;
                    default: new_actions.push(cf); break;
                  }

                  const char_ability = new CharacterAbility();
                  char_ability.copyFeature(cf, this, undefined);
                  new_abilities.push(char_ability);
                } else {
                  const cf = f_finder[0];
                  cf.copyFeature(f, null, this);
                  switch (fb.creature_fb_type) {
                    case "Lair Actions": new_lair_actions.push(cf); break;
                    case "Legendary Actions": new_legendary_actions.push(cf); break;
                    case "Traits": new_special_abilities.push(cf); break;
                    default: new_actions.push(cf); break;
                  }
                  const char_ability = old_abilities.find(o => o.true_id === cf.true_id);
                  if (char_ability) {
                    char_ability.copyFeature(cf, this, undefined);
                    new_abilities.push(char_ability);
                  }
                }
              }
            }
          }
        }
      }
    }
    this.current_senses = { ...this.senses };
    // this.use_resources = new_resources;
    this.actions = new_actions;
    this.legendary_actions = new_legendary_actions;
    this.lair_actions = new_lair_actions;
    this.special_abilities = new_special_abilities;
    this.abilities = new_abilities;
  }

  change_challenge_rating = async (new_cr: number) => {
    if (this.creature) {
      // debugger;
      await this.copyCreature(this.creature, new_cr, false);
      if (this.creature_gifts.length > 0) {
        const cigs = this.creature_gifts.map(o => { return { gift: o.gift, level: o.level }; });
        this.creature_gifts = [];
        for (const cig of cigs) {
          if (cig.gift) {
            this.copyCreatureGift(cig.gift, cig.level);
          }
        }
        await this.connectCreature(this.creature);
      }
      this.subscription_holder.recalculated();
    }
  }
}

export class CreatureInstanceGift {
  true_id = "";
  gift_id = "";
  level = 1;

  gift: CreatureGift | undefined = undefined;
  
  actions: CharacterFeature[] = [];
  special_abilities: CharacterFeature[] = [];
  legendary_actions: CharacterFeature[] = [];
  lair_actions: CharacterFeature[] = [];
  abilities: CharacterAbility[] = [];

  constructor(obj?: any) {
    this.true_id = obj && obj.true_id ? obj.true_id : uuidv4().toString();
    if (obj) {
      this.gift_id = obj.gift_id ? obj.gift_id : "";
      this.level = obj.level ? obj.level : 1;
      
      this.actions = [];
      if (obj.actions && obj.actions.length > 0) {
        obj.actions.forEach((o: any) => {
          this.actions.push(new CharacterFeature(o));
        });
      }

      this.special_abilities = [];
      if (obj.special_abilities && obj.special_abilities.length > 0) {
        obj.special_abilities.forEach((o: any) => {
          this.special_abilities.push(new CharacterFeature(o));
        });
      }

      this.legendary_actions = [];
      if (obj.legendary_actions && obj.legendary_actions.length > 0) {
        obj.legendary_actions.forEach((o: any) => {
          this.legendary_actions.push(new CharacterFeature(o));
        });
      }
      this.lair_actions = [];
      if (obj.lair_actions && obj.lair_actions.length > 0) {
        obj.lair_actions.forEach((o: any) => {
          this.lair_actions.push(new CharacterFeature(o));
        });
      }

      this.abilities = [];
      if (obj.abilities && obj.abilities.length > 0) {
        obj.abilities.forEach((o: any) => {
          this.abilities.push(new CharacterAbility(o));
        });
      }
    }
  }

  get damage_type_overrides_table() {
    return this.gift ? this.gift.damage_type_overrides_table : new DamageTypeOverridesTable();
  }

  toDBObj(): any {
    return {
      true_id: this.true_id,
      gift_id: this.gift_id,
      level: this.level,
      actions: this.actions.map(o => o.toDBObj()),
      legendary_actions: this.legendary_actions.map(o => o.toDBObj()),
      lair_actions: this.lair_actions.map(o => o.toDBObj()),
      special_abilities: this.special_abilities.map(o => o.toDBObj()),
    };
  }

  connectCreatureGift(cg: CreatureGift) {
    this.gift_id = cg._id;
    this.gift = cg;
  }

  clone(): CreatureInstanceGift {
    const clone = new CreatureInstanceGift();
    clone.copy(this);
    return clone;
  }

  copy(copyMe: CreatureInstanceGift): void {
    this.true_id = copyMe.true_id;
    this.gift_id = copyMe.gift_id;
    this.gift = copyMe.gift;
    this.level = copyMe.level;

    this.actions = copyMe.actions.map(o => o.clone());
    this.legendary_actions = copyMe.legendary_actions.map(o => o.clone());
    this.lair_actions = copyMe.lair_actions.map(o => o.clone());
    this.special_abilities = copyMe.special_abilities.map(o => o.clone());
    this.abilities = copyMe.abilities.map(o => o.clone());
  }
}